const initialState = {
  headers: {},
  clientName: "salud",
  dadosCliente: {},
};

const ApiGetnetReducers = (state = initialState, action) => {
  switch (action.type) {
    case "createHeader":
      return { ...state, headers: action.payload };
    case "sellerId":
      return { ...state, clientName: action.payload.clientName };
    case "saveDadosCliente":
      return { ...state, dadosCliente: action.payload };
    default:
      return state;
  }
};

export default ApiGetnetReducers;
